export default "__VITE_ASSET__CBtrLeIE__"